import React from 'react';
import * as LucideIcons from 'lucide-react';
import { useSiteData } from '../contexts/SiteDataContext';

const fallbackSteps = [
  { step: 1, title: "Você envia a foto ou código", description: "Tire uma foto da peça ou nos envie o código de identificação pelo WhatsApp", icon: "Camera" },
  { step: 2, title: "Identificamos a aplicação", description: "Nossa equipe técnica analisa e identifica exatamente qual componente você precisa", icon: "Search" },
  { step: 3, title: "Indicamos a peça correta", description: "Fornecemos especificações técnicas completas e confirmamos compatibilidade", icon: "CheckCircle2" },
  { step: 4, title: "Enviamos para todo o Brasil e Exterior", description: "Preparamos e despachamos sua pe\u00e7a com seguran\u00e7a e rastreamento completo", icon: "Truck" }
];

const HowItWorks = () => {
  const { pageContents } = useSiteData();
  const data = pageContents.how_it_works || {};
  const steps = data.metadata?.steps || fallbackSteps;

  return (
    <section className="py-20 bg-gradient-to-br from-[#055509] to-[#0a7a0f] text-white relative overflow-hidden">
      <div className="absolute inset-0 opacity-5">
        <div className="absolute inset-0" style={{
          backgroundImage: `url("data:image/svg+xml,%3Csvg width='60' height='60' viewBox='0 0 60 60' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='none' fill-rule='evenodd'%3E%3Cg fill='%23ffffff' fill-opacity='1'%3E%3Cpath d='M36 34v-4h-2v4h-4v2h4v4h2v-4h4v-2h-4zm0-30V0h-2v4h-4v2h4v4h2V6h4V4h-4zM6 34v-4H4v4H0v2h4v4h2v-4h4v-2H6zM6 4V0H4v4H0v2h4v4h2V6h4V4H6z'/%3E%3C/g%3E%3C/g%3E%3C/svg%3E")`
        }}></div>
      </div>

      <div className="max-w-7xl mx-auto px-4 relative z-10">
        <div className="text-center mb-16">
          <h2 className="text-4xl font-bold mb-4">{data.title || 'Como Funciona'}</h2>
          <p className="text-xl text-gray-200 max-w-3xl mx-auto">{data.subtitle || 'Processo simples e consultivo para garantir a peça correta'}</p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {steps.map((step, index) => {
            const IconComponent = LucideIcons[step.icon] || LucideIcons.Circle;
            const isLast = index === steps.length - 1;
            return (
              <div key={step.step || index} className="relative">
                {!isLast && <div className="hidden lg:block absolute top-12 left-1/2 w-full h-0.5 bg-[#FFB025] bg-opacity-30 z-0"></div>}
                <div className="relative z-10 text-center">
                  <div className="w-24 h-24 mx-auto mb-6 bg-[#FFB025] rounded-full flex items-center justify-center shadow-2xl relative">
                    <IconComponent size={40} className="text-[#055509]" />
                    <div className="absolute -top-2 -right-2 w-8 h-8 bg-white rounded-full flex items-center justify-center text-[#055509] font-bold text-sm shadow-lg">{step.step || index + 1}</div>
                  </div>
                  <h3 className="text-xl font-bold mb-3">{step.title}</h3>
                  <p className="text-gray-200 text-sm leading-relaxed">{step.description}</p>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default HowItWorks;
